// extracted by mini-css-extract-plugin
export default {"pixel":"ShoveFrame__pixel--2dNZ4","frame":"ShoveFrame__frame--c-_Qw"};